import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import { userLogout, forbiddenAccess } from './auth';

const request = superagent.agent().use(function(req) {
  req.on('response', function(res) {
    if (res.status === 401) {
      console.log('UnAuthorized');
      userLogout();
    } else if (res.status === 403) {
      console.log('Forbidden');
      forbiddenAccess();
    }
  });
});

export function getHelpStart() {
  return {
    type: types.GET_HELP_START,
  };
}

export function getHelpSuccess(content) {
  return {
    type: types.GET_HELP_SUCCESS,
    content,
  };
}

export function getHelpError(error) {
  return {
    type: types.GET_HELP_FAIL,
    error,
  };
}

export function getHelp(id) {
  return (dispatch) => {
    dispatch(getHelpStart());

    return request
      .get(`./notion-static-pages/${id || ''}`)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getHelpSuccess(resp.text));
        } else {
          dispatch(getHelpError(resp.text));
        }
      })
      .catch((ex) => {
        dispatch(getHelpError(ex));
      });
  };
}
